import { jsx as _jsx } from "react/jsx-runtime";
import { BusyBox } from './BusyBox';
const FlexRow = (props) => {
    return _jsx(BusyBox, Object.assign({ alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "center" }, props), void 0);
};
const FlexGrowRow = (props) => {
    return _jsx(FlexRow, Object.assign({ flexGrow: 1 }, props), void 0);
};
export { FlexGrowRow, FlexRow };
//# sourceMappingURL=FlexRow.js.map